export const SIDE_IMAGE_TYPE = {
  DEFAULT: 'default',
  MFA: 'mfa',
};
